import React from 'react';
import BPC_Footer from '../../../assets/images/BPC_Footer.png';

const SubFooter = () => {
  return (
    <div className="mt-auto flex flex-col items-center justify-center py-5">
      <img src={BPC_Footer} className="w-20" alt="BackPaddock Company" />
    </div>
  );
};

export default SubFooter;
